import React from "react";

function ArrowRight() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="35"
            fill="none"
            viewBox="0 0 34 35"
            className="inline-block rtl:rotate-180"
        >
            <path
                fill="#5793EC"
                fillRule="evenodd"
                d="M19.199 16.625l-2.8-2.882 1.203-1.237 4.85 4.994-4.85 4.993-1.202-1.237 2.799-2.881H9.917v-1.75H19.2z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export default ArrowRight;
